import { POST_WITH_ID } from '@brickwise/asset-validation';
import { Typography } from '@mui/material';
import { useFormikContext } from 'formik';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ImageViewList } from 'src/components/ui/ImageViewList';
import { UploadDropzone } from 'src/components/ui/UploadDropzone';

interface Props {
  disabled?: boolean;
}

export const PropertyPhotosImageSelector: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();

  const formik = useFormikContext<POST_WITH_ID>();

  const currentPhotos = formik.values.images?.propertyPhotos || [];

  return (
    <div>
      <Typography paddingTop={2} paddingBottom={2} variant="body1">
        {t('dashboard.assets.addedit.main.propertyPhotos.subtitle')}
      </Typography>
      <UploadDropzone
        disabled={disabled}
        imageUploaded={(url: string, name: string) => {
          formik.setFieldValue('images.propertyPhotos', [
            ...currentPhotos,
            {
              src: url,
              name,
            },
          ]);
        }}
      />
      <ImageViewList disabled={disabled} data={currentPhotos} setData={(data) => formik.setFieldValue('images.propertyPhotos', data)} />
    </div>
  );
};
